module.exports = __webpack_public_path__ + "static/media/canvas_style_active.5fcbe129.svg";